import React from 'react';
import dynamic from 'next/dynamic';

const MobileCorousel = dynamic(() => import('./mobileCorousel'), {
    loading: () => <p>Loading...</p>,
});

const DesktopCorousel = dynamic(() => import('./desktopCorousel'), {
    loading: () => <p>Loading...</p>,
});

export default function HomeCorousel({ isMobile }) {
    return <>{isMobile ? <MobileCorousel /> : <DesktopCorousel />}</>;
}
